var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThankYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#5CB85C",
    stroke: "#5CB85C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1981 41.1455L11.8436 30.6583C11.3035 30.1125 11 29.3716 11 28.5989C11 27.8261 11.3035 27.0852 11.8436 26.5394C12.9685 25.4001 14.7855 25.4001 15.9104 26.5394L24.2459 34.9525L44.0896 14.8545C45.2144 13.7152 47.0315 13.7152 48.1564 14.8545C49.2812 15.9937 49.2812 17.8341 48.1564 18.9734L26.2649 41.1455C25.1689 42.2848 23.3229 42.2848 22.1981 41.1455Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYou);
export default __webpack_public_path__ + "static/media/thank-you.6c1bbc270ac9ac2c7caf1d012efc1521.svg";
export { ForwardRef as ReactComponent };